<template>
  <section class="app-main">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="7" :lg="6" :xl="6">
        <div class="aside" style="margin-right:0;border:1px solid #eee;">
          <Menu></Menu>
          <!-- <div>
            <biaoqian></biaoqian>
          </div> -->
        </div>
      </el-col>
      <el-col :xs="24" :sm="17" :lg="18" :xl="18">
        <div class="contentlist" style="float:left;margin-left:0;border:1px solid #eee;width:99%;">
          <shiyanList></shiyanList>
        </div>
      </el-col>
    </el-row>
    <div id="notice" v-if="this.noticeState == 1">
        <span class="svg-containerN">
          <svg-icon icon-class="NotificatonOnButton" />
        </span>
        <div class="notice-title">
          <span :title="this.noticeTitle">{{this.noticeTitle}}</span>
        </div>
    </div>
    <div id="el-main-footer">
      <div class="info">
        <span>© 2020 上海矩道网络科技有限公司</span>
        <span> ⋅ </span>
        <a href="http://www.beian.miit.gov.cn" target="_blank">沪ICP备16019102号</a>
        <span> ⋅ </span>
        <span>商务QQ:3235186608</span>
        <span> ⋅ </span>
        <span>产品QQ:3512883254</span>
      </div>
    </div>
    <div id="promptBox" v-if="promptShow">
      <div class="prompt">
        <div class="prompt-header">
          <p>
            温馨提示
          </p>
        </div>
        <div class="prompt-main">
          <p>
            矩道小助手提示您！为了更好的体验本公司产品，为了更精准的使用实验中的器件，我们建议您使用更高分辨率的显示器，同时搭配Chrome浏览器帮助您提升整体性能。
          </p>
        </div>
        <div class="prompt-footer">
          <p @click="promptClose">
            确 定
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import request from '@/utils/request'
import biaoqian from '@/components/myComponents/biaoqian'
import shiyanList from '@/components/myComponents/shiyanList'
import Menu from '@/components/myComponents/Menu'

export default {
  name: 'AppMain',
  data(){
    return{
      noticeTitle:'',
      noticeState:'',
      promptShow: false,
      clientWidth: document.documentElement.clientWidth,
      count:'',
    }
  },
  components:{
    Menu,shiyanList,biaoqian
  },
  created(){
    this.isPrompt();
    this.shwoNotice();
    // this.getWidthAndHeight()
  },
  methods:{
    // getWidthAndHeight(){
    //   if(document.body.clientWidth < 1024){

    //   }
    //   document.body.clientWidth
    //   document.body.clientHeight
    // },
    shwoNotice(){
      request({
        method:'get',
        url:'api/notice/tokentrue'
      }).then(res=>{
        if(res.data == null){
          this.noticeState = 0
        }else{
          this.noticeState = res.data[0].state
          this.noticeTitle = res.data[0].content
        }
      })
    },
    isPrompt(){
      if (this.getCookie('prompt') == ''){ // 监测 cookie 中有没有 prompt
        let _this = this;
        _this.clientWidth = document.documentElement.clientWidth;
        if(_this.clientWidth < 1024){
          this.promptShow = false
        }else{
          this.promptShow = false
        }
      }else{
      }
    },
    getCookie(Name) { //cookie
      var search = Name + "=";
      var returnValue = "";
      if (document.cookie.length > 0) {
        var offset = document.cookie.indexOf(search);
        if (offset !== -1) {
          offset += search.length;
          var end = document.cookie.indexOf(";", offset);
          if (end == -1){
            end = document.cookie.length;
          }
          returnValue = decodeURIComponent(document.cookie.substring(offset, end));
        }
      }
      return returnValue;
    },
    promptClose(){
      this.promptShow = false
      document.cookie = "prompt = yes";
    },
  },
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },
}
</script>

<style scoped>
  @import './notice.css'; 
  #promptBox{
    position: fixed;
    left: 0;
    top:0;
    right:0;
    bottom:0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 10000;
  }
  .prompt{
    width: 300px;
    height: 280px;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;
  }
  .prompt p{
    margin: 0;
  }
  .prompt-header{
    height: 30%;
    position: relative;
  }
  .prompt-header p{
    font-size: 24px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #f1ad4e;
  }
  .prompt-main{
    height: 50%;
  }
  .prompt-main p{
    font-size: 12px;
    padding: 0px 26px;
    line-height: 20px;
    letter-spacing:2px;
    text-indent: 30px;
  }
  .prompt-footer{
    height: 20%;
    position: relative;
  }
  .prompt-footer p{
    height: 30px;
    width: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: 30px;
    background-color: #f1ad4e;
    color: #fff;
    border-radius: 4px;
  }
  #el-main-footer{
    background:none repeat scroll 0 0 white;
    border-top:1px solid #e7eaec;
    overflow:hidden;
    font-size:0.7rem !important;
    color:#7a8b9a;
    letter-spacing:0.8px;
    font-family:Arial, sans-serif !important;
    position: fixed;
    bottom: 0;
    height: 32px;
    z-index:1000;
    width: 100%;
  }
  .info{
    position: absolute;
    top: 50%;
    left: 6px;
    transform: translateY(-50%);
  }
  .aside, .contentlist{
    margin: 73px 10px 30px 10px;
    background-color: #fff;
  }
  .app-main {
    /*84 = navbar + tags-view = 50 +34 */
    min-height: calc(100vh - 84px);
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  @media (max-width:1024px) {
    .aside{
      margin-left: 5px !important;
    }
  }
  @media screen and (min-width:1025px) and (max-width:1366px){
    .contentlist{
      margin: 73px 10px 30px 10px;
      margin-left:5px !important;
    }
  }
  @media screen and (min-width:1366px) and (max-width:1440px){
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
  }
  @media (min-width:2049px){
    #el-main-footer{
      height: 60px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue